import React from "react";
import { Box, IconButton } from "@mui/material";
import { Menu as MenuIcon, ChevronLeft } from "@mui/icons-material";
import Logo from "../atoms/logo";
import User from "../user";
import { useSidebar } from "@context/sidebar-context";

const Header = () => {
  const { isOpen, toggleSidebar } = useSidebar();

  return (
    <Box
      sx={{
        pl: 2.5,
        pr: 3,
        display: "flex",
        height: "64px",
        alignItems: "center",
        flexDirection: "row",
        backgroundColor: "#0081C7",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <IconButton
          onClick={toggleSidebar}
          sx={{
            color: "white",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
          }}
        >
          {isOpen ? <ChevronLeft /> : <MenuIcon />}
        </IconButton>
        <Logo width={123} height={42} />
      </Box>
      <Box>
        <User />
      </Box>
    </Box>
  );
};

export default Header;
